import { lazy } from 'react'

export const QuestionnaireV1 = lazy(() => import('./v1/QuestionnaireV1'))
export const QuestionnaireV2 = lazy(() => import('./v2/QuestionnaireV2'))
